module.exports = __webpack_public_path__ + "media/images/stripe_white-574d4ee5c58634b790f0d671e7a9bea7.png";